import React from "react";
import ReactDOM from "react-dom/client";
import "./variables.scss";
import "./index.scss";

import {
  createBrowserRouter,
  RouteObject,
  RouterProvider,
} from "react-router-dom";
import Home from "./components/Home";
import Leaderboard from "./components/Leaderboard";

import { AppContextProvider } from "./context";
import Claim from "./components/Claim";
import CredsBurn from "./components/CredsBurn/CredsBurn";
import Cyberkongz from "./components/Cyberkongz";
import Generator from "./components/Generator/Generator";
import Marketplace from "./components/Marketplace/Marketplace";

export const homeRoute = {
  path: "/",
  element: <Home />,
  index: true,
};

export const gminatorRoute = {
  path: "/gm-inator",
  element: <Generator />,
};

export const claimRoute = {
  path: "/claim",
  element: <Claim />,
};

export const leaderboardRoute = {
  path: "/leaderboard",
  element: <Leaderboard />,
};

export const credsBurnRoute = {
  path: "/creds-burn",
  element: <CredsBurn />,
};

export const cyberkongzRoute = {
  path: "/cyberkongz",
  element: <Cyberkongz />,
};

export const marketplaceRoute = {
  path: "/marketplace",
  element: <Marketplace />,
};

export const layoutRoutes = {
  path: "/",
  children: [
    homeRoute,
    gminatorRoute,
    claimRoute,
    leaderboardRoute,
    cyberkongzRoute,
    marketplaceRoute,
  ],
  errorElement: <Home />,
};

export const routes: RouteObject[] = [layoutRoutes];

const router = createBrowserRouter(routes);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const App = () => {
  return (
    <>
      <React.StrictMode>
        <AppContextProvider>
          <RouterProvider router={router} />
        </AppContextProvider>
      </React.StrictMode>
    </>
  );
};

root.render(<App />);
